var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C13.1046 12.5 14 11.6046 14 10.5C14 9.39543 13.1046 8.5 12 8.5C10.8954 8.5 10 9.39543 10 10.5C10 11.6046 10.8954 12.5 12 12.5ZM12 12.5V15.5M20 12C20 16.4611 14.54 19.6937 12.6414 20.683C12.4361 20.79 12.3334 20.8435 12.191 20.8712C12.08 20.8928 11.92 20.8928 11.809 20.8712C11.6666 20.8435 11.5639 20.79 11.3586 20.683C9.45996 19.6937 4 16.4611 4 12V8.2176C4 7.41809 4 7.01833 4.13076 6.6747C4.24627 6.37114 4.43398 6.10028 4.67766 5.88553C4.9535 5.64244 5.3278 5.50208 6.0764 5.22135L11.4382 3.21067C11.6461 3.13271 11.75 3.09373 11.857 3.07828C11.9518 3.06457 12.0482 3.06457 12.143 3.07828C12.25 3.09373 12.3539 3.13271 12.5618 3.21067L17.9236 5.22135C18.6722 5.50208 19.0465 5.64244 19.3223 5.88553C19.566 6.10028 19.7537 6.37114 19.8692 6.6747C20 7.01833 20 7.41809 20 8.2176V12Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.9b76f9d69238d25636e33421ac6c08d6.svg";
export { ForwardRef as ReactComponent };